<template>
  <div class="update-step">
    <div class="plan-selection-view">
      <h3
        v-html="
          $t(`sub_update.change_plan`, {
            game: $t(`gametypes.groups.${selectedPlan.type.toLowerCase()}_long`),
          })
        "
      ></h3>
      <div class="weight_500 text-small text-grey">
        {{
          !hasStarterOptions
            ? $t(`sub_update.premium_users_can_analyze`, {
                premium_hands_mo: (100000).toLocaleString($i18n.locale),
              })
            : $t(`sub_update.select_plan`)
        }}
      </div>
      <SubscriptionPlanSelector
        v-model="selectedPlanId"
        :current-tier-plan-id="currentTierPlanId"
        :has-starter-options="hasStarterOptions"
        :all-tier-plans="allTierPlans"
        :subscription-tier="subscriptionTier"
        :gm-type="gmType"
        @plan-selected="onPlanSelected"
      />
    </div>
  </div>
</template>

<script>
import SubscriptionPlanSelector from './SubscriptionPlanSelector.vue'

export default {
  name: 'PlanSelectionView',
  components: {
    SubscriptionPlanSelector,
  },
  props: {
    currentTierPlanId: {
      type: String,
      required: true,
    },
    hasStarterOptions: {
      type: Boolean,
      default: false,
    },
    allTierPlans: {
      type: Object,
      required: true,
    },
    subscriptionTier: {
      type: String,
      default: '',
    },
    gmType: {
      type: String,
      default: '',
    },
    selectedPlan: {
      type: Object,
      required: true,
    },
    initialPlanId: {
      type: String,
      default: 'none',
    },
  },
  data() {
    return {
      selectedPlanId: this.initialPlanId,
    }
  },
  methods: {
    onPlanSelected(plan) {
      this.$emit('plan-selected', plan)
    },
  },
  watch: {
    initialPlanId(newVal) {
      this.selectedPlanId = newVal
    },
    selectedPlanId(newVal) {
      this.$emit('update:selectedPlanId', newVal)
    },
  },
}
</script>

<style scoped>
.plan-selection-view {
  width: 100%;
}
</style>
